module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_tokyuhands-0e576ed904f3ca4f6619127fd7e3c461.jpg";